import request from '@/utils/request'
import WebIM from '@/utils/WebIM'
import md5 from 'js-md5'

// 咨询详情
export function getConsultInfo(data) {
  return request({
    url: '/health-cure/cure/consult-reservation/getByConsultId',
    method: 'get',
    params: data
  })
}

// 增加工单备注
export function addWorkOrderRemark(data) {
  return request({
    url: '/health-doctor-assistant/workOrderCenter/v2/workOrderRemark',
    method: 'post',
    data
  })
}

// 查询可推送随访计划
export function getFollowUpCanPush(data) {
  return request({
    url: '/health-followup/followup/plan/getFollowUpCanPush',
    method: 'get',
    params: data
  })
}
// 推送疗效跟踪消息
export function pushEfficacyTrackingMsg(data) {
  return request({
    url: '/health-doctor-assistant/HelpPatient/pushEfficacyTrackingMsg',
    method: 'post',
    data
  })
}
// 患者提交评价to健管
export function pushSatisfactionEvaluation(data) {
  return request({
    url: '/health-patient/patient/doctor/private/pushSatisfactionEvaluation',
    method: 'post',
    data
  })
}
// 获取l历史消息
export function getHistoryMsg(data) {
  return request({
    url: '/im/messages/history',
    method: 'get',
    params: data
  })
}
// 获取全量历史消息
export function getAllHistory(data) {
  return request({
    url: '/im/messages/allHistory',
    method: 'get',
    params: data
  })
}
// 获取历史消息
export function getHistoryByAssistant(data) {
  return request({
    url: '/im/messages/historyByAssistant',
    method: 'get',
    params: data
  })
}
// 批量更新消息已读
export function apiBatchUpdateMsgReader(data) {
  return request({
    url: '/im/messages/batchUpdateMsgReader',
    method: 'post',
    data
  })
}
// 获取已读未读开关
export function apiImOpenReadConfig(data) {
  return request({
    url: '/im/messages/commonConfig',
    method: 'get',
    params: data
  })
}

// 获取群信息
export function groupInfos(data) {
  return request({
    url: '/im/group/infos',
    method: 'get',
    params: data
  })
}
//获取服务端时间
export function currentTimestamp() {
  return request({
    url: '/im/messages/currentTimestamp',
    method: 'get'
  })
}
//量表list
export function getSurveyList(data) {
  return request({
    // url: '/health-doctor/inner/survey/list',
    url: '/health-doctor/survey/list/v2',
    method: 'get',
    params: data
  })
}
//量表list
export function surveySend(data) {
  return request({
    url: '/health-doctor/cure/survey/batch/send/v2',
    method: 'post',
    headers: { _c: 5, _m: 'test' },
    data
  })
}

//医生助手私聊患者
export function talkToPat(data) {
  return request({
    url: '/health-doctor-assistant/workOrder/chatToPatient',
    method: 'post',
    data
  })
}
//健管私聊医生
export function talkToDoctor(data) {
  return request({
    url: 'health-doctor-assistant/workOrder/chatToDoctor',
    method: 'post',
    data
  })
}
//结束处理工单
export function finishChat(data) {
  return request({
    url: '/health-doctor-assistant/workOrderCenter/v2/finish',
    method: 'post',
    data
  })
}

//查询处理中工单对应的groupId 集合
export function queryAllGroupId(data) {
  return request({
    url: '/health-doctor-assistant/workOrder/queryDaHandleGroupIds',
    method: 'get',
    params: data
  })
}

// 环信登录
export function chatLogin(chatId) {
  const options = {
    user: chatId,
    pwd: md5(chatId),
    appKey: WebIM.config.appkey
  }
  WebIM.conn.open(options)
}

//医助-创建随访计划-前置校验
export function plaCreateCheck(data) {
  return request({
    url: '/health-followup/followup/plan/create/check',
    method: 'get',
    params: data
  })
}

//创建随访计划
export function planCreate(data) {
  return request({
    url: '/health-followup/followup/plan/create',
    method: 'post',
    data
  })
}

//医助-创建随访计划-用药周期自动计算生成
export function medicationCycleGenerate(data) {
  return request({
    url: '/health-followup/followup/plan/medicationCycle/generate',
    method: 'post',
    data
  })
}
// 添加提醒
export function consultRemind(doctorId, patientId, remindTime) {
  return request({
    url: '/health-cure/cure/ev-remind/add',
    method: 'post',
    data: {
      doctorId,
      patientId,
      remindTime
    }
  })
}
// 根据医生模糊查询
export function selectByDoctorName(doctorName) {
  return request({
    url: '/user/doctor/selectByDoctorName',
    params: {
      doctorName
    }
  })
}
// 复诊预约
export function appointDoctor(data) {
  return request({
    url: '/health-cure/cure/reserve/makeAnAppointment',
    method: 'get',
    params: data
  })
}
// 常用语 引用次数更新
export function upDatePhraseClassifyNum(data) {
  return request({
    url: '/health-assistant/phraseClassify/cite',
    method: 'post',
    data
  })
}
// 联想常用语
export function queryPhraseClassifyByName(data) {
  return request({
    url: '/health-assistant/phraseClassify/listByName',
    method: 'get',
    params: data
  })
}
// 搜索医生页科室列表
export function departmentList(data) {
  return request({
    url: '/health-user/user/doctor/departmentList',
    method: 'get',
    params: data
  })
}
// 搜索医生城市列表
export function cityList(data) {
  return request({
    url: '/health-user/user/doctor/cityList',
    method: 'get',
    params: data
  })
}
// 搜索医生
export function searchRecommendDoctor(data) {
  return request({
    url: '/health-user/user/doctor/searchDoctor',
    method: 'post',
    data
  })
}

// 推荐医生中获取医生信息
export function fetchRecommendDoctorDetail(data) {
  return request({
    url: '/health-doctor-assistant/HelpPatient/detail',
    method: 'get',
    params: data
  })
}

// 给患者推荐医生
export function pushDoctorsCardtoPatient(data) {
  return request({
    url: '/health-doctor-assistant/HelpPatient/pushDoctorsCard',
    method: 'post',
    data
  })
}
// 绑定医生记录
export function getBindDocList(data) {
  return request({
    url: '/health-user/user/source/getBindDoctorInfo',
    method: 'get',
    params: data
  })
}
// 校验健康信息
export function checkHealthInfo(data) {
  return request({
    url: '/health-emr/health-archives/check-healthInfo',
    method: 'get',
    params: data
  })
}
// 发送健康信息
export function sendHealthInfo(data) {
  return request({
    url: '/health-emr/health-archives/send-healthInfo',
    method: 'get',
    params: data
  })
}
// 服务记录
export function getServiceLog(data) {
  return request({
    url: '/health-emr/health-archives/log/time/query',
    method: 'get',
    params: data
  })
}
// 获取通话记录
export function getCdrList(data) {
  return request({
    url: '/health-doctor-assistant/tccc/page-query',
    method: 'post',
    data
  })
}

//获取问题答案
export function getRquestionAnswer(data) {
  return request({
    url: '/health-message/ai/question-answer',
    method: 'post',
    data
  })
}

//语音转文字（multipart/form-data 上传语音文件）
export function voiceToText(data) {
  return request({
    url: '/health-recommend/recommend/ai/voice/transcribe',
    method: 'post',
    data
  })
}

//获取限制时长
export function getQuestionanswerLimitTime(data) {
  return request({
    url: '/health-message/ai/question-answer-limit-time',
    method: 'get',
    params: data
  })
}

// 获取通话类型枚举
export function getTccType(data) {
  return request({
    url: '/health-doctor-assistant/tccc/call-phone-type/all',
    method: 'get',
    params: data
  })
}
// 获取通话记录筛选条件
export function getTccEndStatus(data) {
  return request({
    url: '/health-message/cdr/tccc-end-status/all',
    method: 'get',
    params: data
  })
}
// 批量完成工单
export function batchFinish(data) {
  return request({
    url: '/health-doctor-assistant/workOrder/batch',
    method: 'post',
    data: data
  })
}
export function getMsgListFrom(data) {
  return request({
    url: '/health-im/im/messages/getEveryGroupRecentCommunicateMsgList',
    method: 'get',
    params: data
  })
}

export function getMsgIndex(data) {
  return request({
    url: '/im/messages/getMsgIndex',
    method: 'get',
    params: data
  })
}
// 获取该医生绑定的所有患者信息、诊费（包括模糊查询）
export function getBindPatientInfoList(data) {
  return request({
    url: '/health-user/user/source/getBindPatientInfoList',
    method: 'get',
    params: data
  })
}

// 获取群聊图片列表
export function getGroupImgMsgUrls(data) {
  return request({
    url: '/health-im/im/messages/getGroupImgMsgUrls',
    method: 'get',
    params: data
  })
}

export function guideRecommendedDoctorInfo(data) {
  return request({
    url: '/health-doctor-assistant/workOrder/guideRecommendedDoctorInfo',
    method: 'get',
    params: data
  })
}

export function traceRecordRecommend(data) {
  return request({
    url: '/health-doctor-assistant/HelpPatient/recommendDoctorSearch/traceRecord',
    method: 'post',
    data
  })
}

export function isShowRecommendDoctor() {
  return request({
    url: '/health-doctor-assistant/HelpPatient/popWindowsConfig',
    method: 'get'
  })
}
// 获取群聊图片列表
export function cancelAppoint(data) {
  return request({
    url: '/health-cure/cure/doctor/cancel/appoint',
    method: 'post',
    data: data
  })
}

// 根据医生id 获取医生所在医院配置
export function getDoctorHospitalSetting(data) {
  return request({
    url: '/health-doctor/user/getDoctorHospitalSetting',
    method: 'get',
    params: data
  })
}

// 根据医生id获取排班信息
export function getDoctorScheduling(data) {
  return request({
    url: '/health-cure/cure/doctor/scheduling',
    method: 'get',
    params: data
  })
}

// 判断群组消息是否已读
export function getFinishPrecheck(data) {
  return request({
    url: '/health-doctor-assistant/workOrderCenter/v2/finish/pre-check',
    method: 'post',
    data
  })
}

// 根据预约单id获取短信模板
export function getSmsTemplateByReserveId(data) {
  return request({
    url: '/health-doctor-assistant/smsTemplateContent/getSmsTemplateByReserveId',
    method: 'get',
    params: data
  })
}

// 根据预约单id发送短信
export function sendSms(data) {
  return request({
    url: '/health-doctor-assistant/sendSms/cureSendSms',
    method: 'get',
    params: data
  })
}

// 获取医生团队标签
export function doctorTeamVest(data) {
  return request({
    url: 'health-user/user/doctor/doctorTeamVest',
    method: 'post',
    data
  })
}
// 医生坐诊机构列表
export function getOutPatientList(data) {
  return request({
    url: 'health-doctor/drOutpatientInfo/list',
    method: 'post',
    data
  })
}
// 根据医生id 获取医生所在医院配置
export function getDoctorHospitalSettingByHospitalId(data) {
  return request({
    url: '/health-doctor/user/getDoctorHospitalSettingByHospitalId',
    method: 'get',
    params: data
  })
}
// 删除医生坐诊机构
export function removeOutPatient(data) {
  return request({
    url: '/health-doctor/drOutpatientInfo/remove',
    method: 'post',
    data
  })
}
// 添加医生坐诊机构
export function addOutPatient(data) {
  return request({
    url: '/health-doctor/drOutpatientInfo/add',
    method: 'post',
    data
  })
}
// 编辑医生坐诊机构排班
export function updateOutPatient(data) {
  return request({
    url: '/health-doctor/drOutpatientInfo/update',
    method: 'post',
    data
  })
}
// 机构（医院）列表 分页
export function getHospitalListByPage(data) {
  return request({
    url: '/health-doctor/hospital/list/page',
    method: 'post',
    data
  })
}
// 点赞
export function messageLike(data) {
  return request({
    url: '/health-im/message/operation/like',
    method: 'post',
    data
  })
}

// 点踩
export function messageDislike(data) {
  return request({
    url: '/health-im/message/operation/dislike',
    method: 'post',
    data
  })
}
// 撤回 ai 发的消息
export function messageRecall(data) {
  return request({
    url: '/health-im/message/operation/recall',
    method: 'post',
    data
  })
}
// 获取职业类型列表
export function getCareerTypeList(data) {
  return request({
    url: '/health-user/user/doctor/careerTypeList',
    method: 'get',
    params: data
  })
}
// 获取职业关联科室列表
export function getDepartmentByCareer(data) {
  return request({
    url: '/health-user/user/doctor/departmentList/new',
    method: 'get',
    params: data
  })
}
// 未购买原因字典集合
export function feedbackReasonList(data) {
  return request({
    url: '/health-doctor-assistant/workOrderCenter/work-order/efficacyFeedbackReasonDictList',
    method: 'get',
    params: data
  })
}
// 查询工单关联处方是否已购
export function getPrescriptionPurchaseByWorkOrderId(data) {
  return request({
    url: '/health-doctor-assistant/workOrderCenter/getPrescriptionPurchaseByWorkOrderId',
    method: 'get',
    params: data
  })
}
export function finishPurchase(data) {
  return request({
    url: '/health-doctor-assistant/workOrderCenter/v2/finish',
    method: 'post',
    data: data
  })
}
// 获取通话记录最后一条全文
export function getTcccLatest(data) {
  return request({
    url: '/health-doctor-assistant/tccc/call-detail-stt/latest',
    method: 'get',
    params: data
  })
}

// 快捷链接发送
export function quickLinkSend(data) {
  return request({
    url: '/health-doctor-assistant/workOrder/doctorQuickLink/send',
    method: 'post',
    data
  })
}

// 根据ID查询预病历及关联处方状态
export function getStateById(data) {
  return request({
    url: '/health-recommend/advanceMedicalRecord/getStateById',
    method: 'get',
    params: data
  })
}
